import { useEffect, useMemo } from 'react';
import { prop } from 'ramda';

import { useGtmEvent } from '@interlayer/js/app/hooks/analiticsSubscribe';
import { useIsPageFullLoaded } from '@interlayer/js/components/system/Page/buzz/hooks/useIsPageFullLoaded';

import { useAppSelector, useAuthSelector, useUserSelector } from '@core/js/store/hooks';
import * as hooks from '@core/js/components/system/App/hooks';
import { useGetTags } from '@core/js/hooks/useGetTags';

export const useAnalyticEvents = () => {
    const gtmEvent = useGtmEvent();
    const isPageFullLoaded = useIsPageFullLoaded();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const [{ isLoading: isAppLoading }] = hooks.useAppInitialResources();
    const [{ isLoading: isTagsLoading }] = useGetTags();
    const skipAutoLoginDependency = useAppSelector(prop('skipAutoLoginDependency'));
    const wasAutoLoginCompleted = useAuthSelector(prop('wasAutoLoginCompleted'));
    const isAppReady = useMemo(() => {
        return !isAppLoading && !isTagsLoading && (wasAutoLoginCompleted || skipAutoLoginDependency);
    }, [isAppLoading, isTagsLoading, skipAutoLoginDependency, wasAutoLoginCompleted]);

    useEffect(() => {
        if (isPageFullLoaded) {
            gtmEvent('After page rendered');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPageFullLoaded]);

    useEffect(() => {
        gtmEvent('User session changed');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    useEffect(() => {
        if (isAppReady) {
            gtmEvent('App ready');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAppReady]);
};
